export const globalInvoiceStatusTypes = {
  HANDLE_GLOBAL_INVOICE_STATUS_INPUTS: "HANDLE_GLOBAL_INVOICE_STATUS_INPUTS",
  GET_GLOBAL_INVOICE_STATUS: "GET_GLOBAL_INVOICE_STATUS",
};
